import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

const roleFallback = (role) => {
    if (role === "employee") return "/portale";
    return "/";
};

export const ProtectedRoute = ({ children, requireRole }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="flex h-screen items-center justify-center" data-testid="auth-loading">
                <Loader2 className="h-6 w-6 animate-spin text-slate-500" />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/accesso" replace />;
    }
    const roles = Array.isArray(requireRole) ? requireRole : requireRole ? [requireRole] : null;
    if (roles && !roles.includes(user.role)) {
        return <Navigate to={roleFallback(user.role)} replace />;
    }
    return children;
};
